// import PropTypes from 'prop-types';
// // @mui
// import Button from '@mui/material/Button';
// // routes
// import { RouterLink } from 'src/routes/components';
// // config
// import { PATH_AFTER_LOGIN } from 'src/config-global';

// // ----------------------------------------------------------------------

// export default function LoginButton({ sx }) {
//   return (
//     <Button component={RouterLink} href={PATH_AFTER_LOGIN} variant="outlined" sx={{ mr: 1, ...sx }}>
//       Login
//     </Button>
//   );
// }

// LoginButton.propTypes = {
//   sx: PropTypes.object,
// };

import PropTypes from 'prop-types';
// @mui
import Button from '@mui/material/Button';
// routes
import { RouterLink } from 'src/routes/components';
// config
import { Box } from '@mui/material';
import { useResponsive } from 'src/hooks/use-responsive';
import { useMockedUser } from 'src/hooks/use-mocked-user';
import { PATH_AFTER_LOGIN } from 'src/config-global';

// ----------------------------------------------------------------------

export default function LoginButton({ sx }) {

  const { user } = useMockedUser();

  const isMd = useResponsive("up", "md");


  return (
    <>
      {isMd ? user ? (
        <Button component={RouterLink} href={PATH_AFTER_LOGIN} variant="contained" color="primary" sx={{ mr: 1, ...sx }}>
          Dashboard
        </Button>
      ) : (
        <Button component={RouterLink} href={'/login'} variant="outlined" sx={{ mr: 1, ...sx }}>
          Login
        </Button>
      ) :
        <Box sx={{ width: '100%', textAlign: 'center', mt: 2, px: 2 }}>
          {user ? (
            <Button component={RouterLink} href={PATH_AFTER_LOGIN} variant="contained" color="primary" sx={{ width: 1, mr: 1, ...sx }}>
              Dashboard
            </Button>
          ) : (
            <Button component={RouterLink} href={'/login'} variant="outlined" sx={{ width: 1, mr: 1, ...sx }}>
              Login
            </Button>
          )}
        </Box>

      }
    </>
  );
}

LoginButton.propTypes = {
  sx: PropTypes.object,
};

